import { render, staticRenderFns } from "./showBom.vue?vue&type=template&id=caa5983a"
import script from "./showBom.vue?vue&type=script&lang=js"
export * from "./showBom.vue?vue&type=script&lang=js"
import style0 from "./showBom.vue?vue&type=style&index=0&id=caa5983a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports